module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2015-12-10",
		"endpointPrefix": "servicecatalog",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceFullName": "AWS Service Catalog",
		"signatureVersion": "v4",
		"targetPrefix": "AWS242ServiceCatalogService",
		"uid": "servicecatalog-2015-12-10"
	},
	"operations": {
		"AcceptPortfolioShare": {
			"input": {
				"type": "structure",
				"required": [
					"PortfolioId"
				],
				"members": {
					"AcceptLanguage": {},
					"PortfolioId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AssociatePrincipalWithPortfolio": {
			"input": {
				"type": "structure",
				"required": [
					"PortfolioId",
					"PrincipalARN",
					"PrincipalType"
				],
				"members": {
					"AcceptLanguage": {},
					"PortfolioId": {},
					"PrincipalARN": {},
					"PrincipalType": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AssociateProductWithPortfolio": {
			"input": {
				"type": "structure",
				"required": [
					"ProductId",
					"PortfolioId"
				],
				"members": {
					"AcceptLanguage": {},
					"ProductId": {},
					"PortfolioId": {},
					"SourcePortfolioId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AssociateTagOptionWithResource": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceId",
					"TagOptionId"
				],
				"members": {
					"ResourceId": {},
					"TagOptionId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"CreateConstraint": {
			"input": {
				"type": "structure",
				"required": [
					"PortfolioId",
					"ProductId",
					"Parameters",
					"Type",
					"IdempotencyToken"
				],
				"members": {
					"AcceptLanguage": {},
					"PortfolioId": {},
					"ProductId": {},
					"Parameters": {},
					"Type": {},
					"Description": {},
					"IdempotencyToken": {
						"idempotencyToken": true
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ConstraintDetail": {
						"shape": "Sl"
					},
					"ConstraintParameters": {},
					"Status": {}
				}
			}
		},
		"CreatePortfolio": {
			"input": {
				"type": "structure",
				"required": [
					"DisplayName",
					"ProviderName",
					"IdempotencyToken"
				],
				"members": {
					"AcceptLanguage": {},
					"DisplayName": {},
					"Description": {},
					"ProviderName": {},
					"Tags": {
						"shape": "Ss"
					},
					"IdempotencyToken": {
						"idempotencyToken": true
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"PortfolioDetail": {
						"shape": "Sx"
					},
					"Tags": {
						"shape": "S10"
					}
				}
			}
		},
		"CreatePortfolioShare": {
			"input": {
				"type": "structure",
				"required": [
					"PortfolioId",
					"AccountId"
				],
				"members": {
					"AcceptLanguage": {},
					"PortfolioId": {},
					"AccountId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"CreateProduct": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"Owner",
					"ProductType",
					"ProvisioningArtifactParameters",
					"IdempotencyToken"
				],
				"members": {
					"AcceptLanguage": {},
					"Name": {},
					"Owner": {},
					"Description": {},
					"Distributor": {},
					"SupportDescription": {},
					"SupportEmail": {},
					"SupportUrl": {},
					"ProductType": {},
					"Tags": {
						"shape": "Ss"
					},
					"ProvisioningArtifactParameters": {
						"shape": "S1b"
					},
					"IdempotencyToken": {
						"idempotencyToken": true
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ProductViewDetail": {
						"shape": "S1j"
					},
					"ProvisioningArtifactDetail": {
						"shape": "S1o"
					},
					"Tags": {
						"shape": "S10"
					}
				}
			}
		},
		"CreateProvisioningArtifact": {
			"input": {
				"type": "structure",
				"required": [
					"ProductId",
					"Parameters",
					"IdempotencyToken"
				],
				"members": {
					"AcceptLanguage": {},
					"ProductId": {},
					"Parameters": {
						"shape": "S1b"
					},
					"IdempotencyToken": {
						"idempotencyToken": true
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ProvisioningArtifactDetail": {
						"shape": "S1o"
					},
					"Info": {
						"shape": "S1e"
					},
					"Status": {}
				}
			}
		},
		"CreateTagOption": {
			"input": {
				"type": "structure",
				"required": [
					"Key",
					"Value"
				],
				"members": {
					"Key": {},
					"Value": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TagOptionDetail": {
						"shape": "S1v"
					}
				}
			}
		},
		"DeleteConstraint": {
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"AcceptLanguage": {},
					"Id": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeletePortfolio": {
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"AcceptLanguage": {},
					"Id": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeletePortfolioShare": {
			"input": {
				"type": "structure",
				"required": [
					"PortfolioId",
					"AccountId"
				],
				"members": {
					"AcceptLanguage": {},
					"PortfolioId": {},
					"AccountId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeleteProduct": {
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"AcceptLanguage": {},
					"Id": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeleteProvisioningArtifact": {
			"input": {
				"type": "structure",
				"required": [
					"ProductId",
					"ProvisioningArtifactId"
				],
				"members": {
					"AcceptLanguage": {},
					"ProductId": {},
					"ProvisioningArtifactId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DescribeConstraint": {
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"AcceptLanguage": {},
					"Id": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ConstraintDetail": {
						"shape": "Sl"
					},
					"ConstraintParameters": {},
					"Status": {}
				}
			}
		},
		"DescribePortfolio": {
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"AcceptLanguage": {},
					"Id": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"PortfolioDetail": {
						"shape": "Sx"
					},
					"Tags": {
						"shape": "S10"
					},
					"TagOptions": {
						"shape": "S2b"
					}
				}
			}
		},
		"DescribeProduct": {
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"AcceptLanguage": {},
					"Id": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ProductViewSummary": {
						"shape": "S1k"
					},
					"ProvisioningArtifacts": {
						"shape": "S2e"
					}
				}
			}
		},
		"DescribeProductAsAdmin": {
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"AcceptLanguage": {},
					"Id": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ProductViewDetail": {
						"shape": "S1j"
					},
					"ProvisioningArtifactSummaries": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Id": {},
								"Name": {},
								"Description": {},
								"CreatedTime": {
									"type": "timestamp"
								},
								"ProvisioningArtifactMetadata": {
									"shape": "S1e"
								}
							}
						}
					},
					"Tags": {
						"shape": "S10"
					},
					"TagOptions": {
						"shape": "S2b"
					}
				}
			}
		},
		"DescribeProductView": {
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"AcceptLanguage": {},
					"Id": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ProductViewSummary": {
						"shape": "S1k"
					},
					"ProvisioningArtifacts": {
						"shape": "S2e"
					}
				}
			}
		},
		"DescribeProvisionedProduct": {
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"AcceptLanguage": {},
					"Id": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ProvisionedProductDetail": {
						"shape": "S2p"
					}
				}
			}
		},
		"DescribeProvisioningArtifact": {
			"input": {
				"type": "structure",
				"required": [
					"ProvisioningArtifactId",
					"ProductId"
				],
				"members": {
					"AcceptLanguage": {},
					"ProvisioningArtifactId": {},
					"ProductId": {},
					"Verbose": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ProvisioningArtifactDetail": {
						"shape": "S1o"
					},
					"Info": {
						"shape": "S1e"
					},
					"Status": {}
				}
			}
		},
		"DescribeProvisioningParameters": {
			"input": {
				"type": "structure",
				"required": [
					"ProductId",
					"ProvisioningArtifactId"
				],
				"members": {
					"AcceptLanguage": {},
					"ProductId": {},
					"ProvisioningArtifactId": {},
					"PathId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ProvisioningArtifactParameters": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"ParameterKey": {},
								"DefaultValue": {},
								"ParameterType": {},
								"IsNoEcho": {
									"type": "boolean"
								},
								"Description": {},
								"ParameterConstraints": {
									"type": "structure",
									"members": {
										"AllowedValues": {
											"type": "list",
											"member": {}
										}
									}
								}
							}
						}
					},
					"ConstraintSummaries": {
						"shape": "S3b"
					},
					"UsageInstructions": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Type": {},
								"Value": {}
							}
						}
					},
					"TagOptions": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Key": {},
								"Values": {
									"type": "list",
									"member": {}
								}
							}
						}
					}
				}
			}
		},
		"DescribeRecord": {
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"AcceptLanguage": {},
					"Id": {},
					"PageToken": {},
					"PageSize": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"RecordDetail": {
						"shape": "S3o"
					},
					"RecordOutputs": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"OutputKey": {},
								"OutputValue": {},
								"Description": {}
							}
						}
					},
					"NextPageToken": {}
				}
			}
		},
		"DescribeTagOption": {
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TagOptionDetail": {
						"shape": "S1v"
					}
				}
			}
		},
		"DisassociatePrincipalFromPortfolio": {
			"input": {
				"type": "structure",
				"required": [
					"PortfolioId",
					"PrincipalARN"
				],
				"members": {
					"AcceptLanguage": {},
					"PortfolioId": {},
					"PrincipalARN": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DisassociateProductFromPortfolio": {
			"input": {
				"type": "structure",
				"required": [
					"ProductId",
					"PortfolioId"
				],
				"members": {
					"AcceptLanguage": {},
					"ProductId": {},
					"PortfolioId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DisassociateTagOptionFromResource": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceId",
					"TagOptionId"
				],
				"members": {
					"ResourceId": {},
					"TagOptionId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"ListAcceptedPortfolioShares": {
			"input": {
				"type": "structure",
				"members": {
					"AcceptLanguage": {},
					"PageToken": {},
					"PageSize": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"PortfolioDetails": {
						"shape": "S4f"
					},
					"NextPageToken": {}
				}
			}
		},
		"ListConstraintsForPortfolio": {
			"input": {
				"type": "structure",
				"required": [
					"PortfolioId"
				],
				"members": {
					"AcceptLanguage": {},
					"PortfolioId": {},
					"ProductId": {},
					"PageSize": {
						"type": "integer"
					},
					"PageToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ConstraintDetails": {
						"type": "list",
						"member": {
							"shape": "Sl"
						}
					},
					"NextPageToken": {}
				}
			}
		},
		"ListLaunchPaths": {
			"input": {
				"type": "structure",
				"required": [
					"ProductId"
				],
				"members": {
					"AcceptLanguage": {},
					"ProductId": {},
					"PageSize": {
						"type": "integer"
					},
					"PageToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"LaunchPathSummaries": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Id": {},
								"ConstraintSummaries": {
									"shape": "S3b"
								},
								"Tags": {
									"shape": "S10"
								},
								"Name": {}
							}
						}
					},
					"NextPageToken": {}
				}
			}
		},
		"ListPortfolioAccess": {
			"input": {
				"type": "structure",
				"required": [
					"PortfolioId"
				],
				"members": {
					"AcceptLanguage": {},
					"PortfolioId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"AccountIds": {
						"type": "list",
						"member": {}
					},
					"NextPageToken": {}
				}
			}
		},
		"ListPortfolios": {
			"input": {
				"type": "structure",
				"members": {
					"AcceptLanguage": {},
					"PageToken": {},
					"PageSize": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"PortfolioDetails": {
						"shape": "S4f"
					},
					"NextPageToken": {}
				}
			}
		},
		"ListPortfoliosForProduct": {
			"input": {
				"type": "structure",
				"required": [
					"ProductId"
				],
				"members": {
					"AcceptLanguage": {},
					"ProductId": {},
					"PageToken": {},
					"PageSize": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"PortfolioDetails": {
						"shape": "S4f"
					},
					"NextPageToken": {}
				}
			}
		},
		"ListPrincipalsForPortfolio": {
			"input": {
				"type": "structure",
				"required": [
					"PortfolioId"
				],
				"members": {
					"AcceptLanguage": {},
					"PortfolioId": {},
					"PageSize": {
						"type": "integer"
					},
					"PageToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Principals": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"PrincipalARN": {},
								"PrincipalType": {}
							}
						}
					},
					"NextPageToken": {}
				}
			}
		},
		"ListProvisioningArtifacts": {
			"input": {
				"type": "structure",
				"required": [
					"ProductId"
				],
				"members": {
					"AcceptLanguage": {},
					"ProductId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ProvisioningArtifactDetails": {
						"type": "list",
						"member": {
							"shape": "S1o"
						}
					},
					"NextPageToken": {}
				}
			}
		},
		"ListRecordHistory": {
			"input": {
				"type": "structure",
				"members": {
					"AcceptLanguage": {},
					"AccessLevelFilter": {
						"shape": "S53"
					},
					"SearchFilter": {
						"type": "structure",
						"members": {
							"Key": {},
							"Value": {}
						}
					},
					"PageSize": {
						"type": "integer"
					},
					"PageToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"RecordDetails": {
						"type": "list",
						"member": {
							"shape": "S3o"
						}
					},
					"NextPageToken": {}
				}
			}
		},
		"ListResourcesForTagOption": {
			"input": {
				"type": "structure",
				"required": [
					"TagOptionId"
				],
				"members": {
					"TagOptionId": {},
					"ResourceType": {},
					"PageSize": {
						"type": "integer"
					},
					"PageToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ResourceDetails": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Id": {},
								"ARN": {},
								"Name": {},
								"Description": {},
								"CreatedTime": {
									"type": "timestamp"
								}
							}
						}
					},
					"PageToken": {}
				}
			}
		},
		"ListTagOptions": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"type": "structure",
						"members": {
							"Key": {},
							"Value": {},
							"Active": {
								"type": "boolean"
							}
						}
					},
					"PageSize": {
						"type": "integer"
					},
					"PageToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TagOptionDetails": {
						"shape": "S2b"
					},
					"PageToken": {}
				}
			}
		},
		"ProvisionProduct": {
			"input": {
				"type": "structure",
				"required": [
					"ProductId",
					"ProvisioningArtifactId",
					"ProvisionedProductName",
					"ProvisionToken"
				],
				"members": {
					"AcceptLanguage": {},
					"ProductId": {},
					"ProvisioningArtifactId": {},
					"PathId": {},
					"ProvisionedProductName": {},
					"ProvisioningParameters": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Key": {},
								"Value": {}
							}
						}
					},
					"Tags": {
						"shape": "S10"
					},
					"NotificationArns": {
						"type": "list",
						"member": {}
					},
					"ProvisionToken": {
						"idempotencyToken": true
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"RecordDetail": {
						"shape": "S3o"
					}
				}
			}
		},
		"RejectPortfolioShare": {
			"input": {
				"type": "structure",
				"required": [
					"PortfolioId"
				],
				"members": {
					"AcceptLanguage": {},
					"PortfolioId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"ScanProvisionedProducts": {
			"input": {
				"type": "structure",
				"members": {
					"AcceptLanguage": {},
					"AccessLevelFilter": {
						"shape": "S53"
					},
					"PageSize": {
						"type": "integer"
					},
					"PageToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ProvisionedProducts": {
						"type": "list",
						"member": {
							"shape": "S2p"
						}
					},
					"NextPageToken": {}
				}
			}
		},
		"SearchProducts": {
			"input": {
				"type": "structure",
				"members": {
					"AcceptLanguage": {},
					"Filters": {
						"shape": "S61"
					},
					"PageSize": {
						"type": "integer"
					},
					"SortBy": {},
					"SortOrder": {},
					"PageToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ProductViewSummaries": {
						"type": "list",
						"member": {
							"shape": "S1k"
						}
					},
					"ProductViewAggregations": {
						"type": "map",
						"key": {},
						"value": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Value": {},
									"ApproximateCount": {
										"type": "integer"
									}
								}
							}
						}
					},
					"NextPageToken": {}
				}
			}
		},
		"SearchProductsAsAdmin": {
			"input": {
				"type": "structure",
				"members": {
					"AcceptLanguage": {},
					"PortfolioId": {},
					"Filters": {
						"shape": "S61"
					},
					"SortBy": {},
					"SortOrder": {},
					"PageToken": {},
					"PageSize": {
						"type": "integer"
					},
					"ProductSource": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ProductViewDetails": {
						"type": "list",
						"member": {
							"shape": "S1j"
						}
					},
					"NextPageToken": {}
				}
			}
		},
		"TerminateProvisionedProduct": {
			"input": {
				"type": "structure",
				"required": [
					"TerminateToken"
				],
				"members": {
					"ProvisionedProductName": {},
					"ProvisionedProductId": {},
					"TerminateToken": {
						"idempotencyToken": true
					},
					"IgnoreErrors": {
						"type": "boolean"
					},
					"AcceptLanguage": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"RecordDetail": {
						"shape": "S3o"
					}
				}
			}
		},
		"UpdateConstraint": {
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"AcceptLanguage": {},
					"Id": {},
					"Description": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ConstraintDetail": {
						"shape": "Sl"
					},
					"ConstraintParameters": {},
					"Status": {}
				}
			}
		},
		"UpdatePortfolio": {
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"AcceptLanguage": {},
					"Id": {},
					"DisplayName": {},
					"Description": {},
					"ProviderName": {},
					"AddTags": {
						"shape": "Ss"
					},
					"RemoveTags": {
						"shape": "S6p"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"PortfolioDetail": {
						"shape": "Sx"
					},
					"Tags": {
						"shape": "S10"
					}
				}
			}
		},
		"UpdateProduct": {
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"AcceptLanguage": {},
					"Id": {},
					"Name": {},
					"Owner": {},
					"Description": {},
					"Distributor": {},
					"SupportDescription": {},
					"SupportEmail": {},
					"SupportUrl": {},
					"AddTags": {
						"shape": "Ss"
					},
					"RemoveTags": {
						"shape": "S6p"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ProductViewDetail": {
						"shape": "S1j"
					},
					"Tags": {
						"shape": "S10"
					}
				}
			}
		},
		"UpdateProvisionedProduct": {
			"input": {
				"type": "structure",
				"required": [
					"UpdateToken"
				],
				"members": {
					"AcceptLanguage": {},
					"ProvisionedProductName": {},
					"ProvisionedProductId": {},
					"ProductId": {},
					"ProvisioningArtifactId": {},
					"PathId": {},
					"ProvisioningParameters": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Key": {},
								"Value": {},
								"UsePreviousValue": {
									"type": "boolean"
								}
							}
						}
					},
					"UpdateToken": {
						"idempotencyToken": true
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"RecordDetail": {
						"shape": "S3o"
					}
				}
			}
		},
		"UpdateProvisioningArtifact": {
			"input": {
				"type": "structure",
				"required": [
					"ProductId",
					"ProvisioningArtifactId"
				],
				"members": {
					"AcceptLanguage": {},
					"ProductId": {},
					"ProvisioningArtifactId": {},
					"Name": {},
					"Description": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ProvisioningArtifactDetail": {
						"shape": "S1o"
					},
					"Info": {
						"shape": "S1e"
					},
					"Status": {}
				}
			}
		},
		"UpdateTagOption": {
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {},
					"Value": {},
					"Active": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TagOptionDetail": {
						"shape": "S1v"
					}
				}
			}
		}
	},
	"shapes": {
		"Sl": {
			"type": "structure",
			"members": {
				"ConstraintId": {},
				"Type": {},
				"Description": {},
				"Owner": {}
			}
		},
		"Ss": {
			"type": "list",
			"member": {
				"shape": "St"
			}
		},
		"St": {
			"type": "structure",
			"required": [
				"Key",
				"Value"
			],
			"members": {
				"Key": {},
				"Value": {}
			}
		},
		"Sx": {
			"type": "structure",
			"members": {
				"Id": {},
				"ARN": {},
				"DisplayName": {},
				"Description": {},
				"CreatedTime": {
					"type": "timestamp"
				},
				"ProviderName": {}
			}
		},
		"S10": {
			"type": "list",
			"member": {
				"shape": "St"
			}
		},
		"S1b": {
			"type": "structure",
			"required": [
				"Info"
			],
			"members": {
				"Name": {},
				"Description": {},
				"Info": {
					"shape": "S1e"
				},
				"Type": {}
			}
		},
		"S1e": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S1j": {
			"type": "structure",
			"members": {
				"ProductViewSummary": {
					"shape": "S1k"
				},
				"Status": {},
				"ProductARN": {},
				"CreatedTime": {
					"type": "timestamp"
				}
			}
		},
		"S1k": {
			"type": "structure",
			"members": {
				"Id": {},
				"ProductId": {},
				"Name": {},
				"Owner": {},
				"ShortDescription": {},
				"Type": {},
				"Distributor": {},
				"HasDefaultPath": {
					"type": "boolean"
				},
				"SupportEmail": {},
				"SupportDescription": {},
				"SupportUrl": {}
			}
		},
		"S1o": {
			"type": "structure",
			"members": {
				"Id": {},
				"Name": {},
				"Description": {},
				"Type": {},
				"CreatedTime": {
					"type": "timestamp"
				}
			}
		},
		"S1v": {
			"type": "structure",
			"members": {
				"Key": {},
				"Value": {},
				"Active": {
					"type": "boolean"
				},
				"Id": {}
			}
		},
		"S2b": {
			"type": "list",
			"member": {
				"shape": "S1v"
			}
		},
		"S2e": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"Id": {},
					"Name": {},
					"Description": {},
					"CreatedTime": {
						"type": "timestamp"
					}
				}
			}
		},
		"S2p": {
			"type": "structure",
			"members": {
				"Name": {},
				"Arn": {},
				"Type": {},
				"Id": {},
				"Status": {},
				"StatusMessage": {},
				"CreatedTime": {
					"type": "timestamp"
				},
				"IdempotencyToken": {},
				"LastRecordId": {}
			}
		},
		"S3b": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"Type": {},
					"Description": {}
				}
			}
		},
		"S3o": {
			"type": "structure",
			"members": {
				"RecordId": {},
				"ProvisionedProductName": {},
				"Status": {},
				"CreatedTime": {
					"type": "timestamp"
				},
				"UpdatedTime": {
					"type": "timestamp"
				},
				"ProvisionedProductType": {},
				"RecordType": {},
				"ProvisionedProductId": {},
				"ProductId": {},
				"ProvisioningArtifactId": {},
				"PathId": {},
				"RecordErrors": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"Code": {},
							"Description": {}
						}
					}
				},
				"RecordTags": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"Key": {},
							"Value": {}
						}
					}
				}
			}
		},
		"S4f": {
			"type": "list",
			"member": {
				"shape": "Sx"
			}
		},
		"S53": {
			"type": "structure",
			"members": {
				"Key": {},
				"Value": {}
			}
		},
		"S61": {
			"type": "map",
			"key": {},
			"value": {
				"type": "list",
				"member": {}
			}
		},
		"S6p": {
			"type": "list",
			"member": {}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/servicecatalog-2015-12-10.min.json
// module id = 692
// module chunks = 0